
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsEndDayCashierDialog extends Serenity.EntityDialog<PsEndDayCashierRow, any> {
        protected getFormKey() { return PsEndDayCashierForm.formKey; }
        protected getIdProperty() { return PsEndDayCashierRow.idProperty; }
        protected getLocalTextPrefix() { return PsEndDayCashierRow.localTextPrefix; }
        protected getNameProperty() { return PsEndDayCashierRow.nameProperty; }
        protected getService() { return PsEndDayCashierService.baseUrl; }
        protected getDeletePermission() { return PsEndDayCashierRow.deletePermission; }
        protected getInsertPermission() { return PsEndDayCashierRow.insertPermission; }
        protected getUpdatePermission() { return PsEndDayCashierRow.updatePermission; }

        protected form = new PsEndDayCashierForm(this.idPrefix);

    }
}